import React, { useRef } from 'react';

const DateInput = ({ 
  type = "date", 
  className = "form-control", 
  value, 
  onChange, 
  name, 
  placeholder,
  required,
  disabled,
  ...props 
}) => {
  const inputRef = useRef(null);

  const handleClick = () => {
    if (inputRef.current && !disabled) {
      // Focus the input and trigger the date picker
      inputRef.current.focus();
      inputRef.current.showPicker?.();
    }
  };

  const handleKeyDown = (e) => {
    // Allow normal input behavior for keyboard users
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <input
      ref={inputRef}
      type={type}
      className={className}
      value={value}
      onChange={onChange}
      name={name}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={{ 
        cursor: disabled ? 'not-allowed' : 'pointer',
        userSelect: 'none', // Prevent text selection on click
        ...props.style 
      }}
      {...props}
    />
  );
};

export default DateInput;
